/*LIBRARY MODULE*/
import { useEffect, useState } from "react";
import { connect } from "react-redux";

/*PERSONAL COMPONENT*/

/*REDUX FUNCTION*/
import { set_modal_quota_access } from "../../App/actions/authActions";
import ICON_SUCCESS from "../../Assets/jsx/ICON_SUCCESS";
import { pushFeatureV2 } from "../../App/actions/layerActions";
import randomColor from "randomcolor";
import { uuid } from "../../App/validation";
import { verify_license_group } from "../../App/actions/license_actions";

/*PICTURE ASSET*/

/*GENERAL*/

/*NON IMPORT*/

const ErrorFreeKai = ({
  auth,
  properties,
  layer,
  license,
  pushFeatureV2,
  from,
  verify_license_group
}) => {
  const user = auth?.user;

  const is_in_collaborators = license?.license_group_status?.collaborator_id ? "Ada" : "Tidak ada";

  const [button_status, setButtonStatus] = useState(null);
  const [network_state, set_network_state] = useState("no_checked");

  const check_network_status = () => {
    if (navigator.onLine) {
      set_network_state("online");
    } else {
      set_network_state("offline");
    }
  };

  useEffect(() => {
    check_network_status();

    const handle_online = () => {
      set_network_state("online");
    };

    const handle_offline = () => {
      set_network_state("offline");
    };

    window.addEventListener("online", handle_online);
    window.addEventListener("offline", handle_offline);

    return () => {
      window.removeEventListener("online", handle_online);
      window.removeEventListener("offline", handle_offline);
    };
  }, []);

  const refresh_satus = async () => {
    await verify_license_group();
  }

  const laporkan = async () => {
    const latitude = 0,
      longitude = 0;

    let prop = {
      icon_image: "museum",
      text_field: "icon_image",
      circle_color: randomColor(),
      circle_radius: 5,
      circle_stroke_width: 1,
      circle_stroke_color: "#fff",
    };

    let coordinates = {
      coordinates: [Number(longitude), Number(latitude)],
      type: "Point",
    };


    const user_id = auth?.user?._id;
    const full_name = auth?.user?.kai_object?.nama;
    const nipp = auth?.user?.kai_object?.nipp
    const collaborator_id = license?.license_group_status?.collaborator_id;
    const license_personal_expired = license?.license_user_status?.date_finish;
    const license_group_expired = license?.license_group_status?.date_finish;
    const access_date = new Date().toISOString();
    const description = `kena block dari ${from || "unknown source"}`;
    prop = {
      ...prop,
      full_name,
      nipp,
      user_id,
      collaborator_id,
      license_personal_expired,
      license_group_expired,
      access_date,
      description,
      version: process.env.REACT_APP_VERSION,
    };

    const key = uuid();

    let feature = {
      key,
      type: "Feature",
      properties: prop,
      formStatus: {
        status: "digitasi",
        message: "",
        revision_list: [],
      },
      geometry: coordinates,
      isHide: false,
      child_array: [],
      counting_custom_array: [],
      data_pembanding_list: [],
    };
    const body = {
      geo_layer_id: "692fdebb64ef789a83de110d",
      feature,
    };

    const res = await pushFeatureV2(body, false);
    if (res?.status === 200) {
      setButtonStatus("success");
    } else {
      setButtonStatus("error");
    }
  };

  let button_content = null;
  if (!button_status || button_status === "error") {
    button_content = (
      <button
        className="button_big bg_blue text_white"
        onClick={() => {
          laporkan();
        }}
      >
        {button_status === "error" ? "Laporkan Ulang" : "Laporkan"}
      </button>
    );
  } else if (button_status === "success") {
    button_content = (
      <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
        <ICON_SUCCESS />
        <span>sudah disubmit</span>
      </div>
    );
  }

  return (
    <main>
      <h1 className="text_big">
        Pastikan akun HRIS NIPP Anda sudah masuk ke grup KIM KAI
      </h1>
      <br />
      <br />
      <section className="container background_grey_light margin_bottom">
        <p className="text_medium margin_bottom">Status NIPP</p>
        <table className="table full_width margin_bottom">
          <tbody>
            <tr>
              <td>NIPP</td>
              <td>{user?.kai_object?.nipp || "-"}</td>
            </tr>
            <tr>
              <td>User name</td>
              <td>{user?.name || "-"}</td>
            </tr>
            <tr>
              <td>Full name</td>
              <td>{user?.full_name || "-"}</td>
            </tr>
            <tr>
              <td>jabatan</td>
              <td>{user?.kai_object?.jabatan || "-"}</td>
            </tr>
            <tr>
              <td>unit</td>
              <td>{user?.kai_object?.unit || "-"}</td>
            </tr>
            <tr>
              <td>area</td>
              <td>{user?.kai_object?.area || "-"}</td>
            </tr>
          </tbody>
        </table>
        <hr />
        <p className="text_medium margin_bottom">Status Sistem</p>
        <table className="table full_width">
          <tbody>
            <tr>
              <td>Status internet</td>
              <td>{network_state}</td>
            </tr>
            <tr>
              <td>Status grup</td>
              <td>{is_in_collaborators}</td>
            </tr>
          </tbody>
        </table>
      </section>
      <section className="container background_grey_light">
        <p className="text_medium">Tindak lanjut</p>
        <br />
        <div className="margin_bottom">{button_content}</div>
        <button
          className="button_big background_black"
          onClick={refresh_satus}
        >
          Refresh status
        </button>
      </section>
    </main>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  properties: state.properties,
  layer: state.layer,
  license: state.license_reducer,
});

export default connect(mapStateToProps, {
  set_modal_quota_access,
  pushFeatureV2,
  verify_license_group,
})(ErrorFreeKai);
